/* istanbul ignore file */
import { langIdOnLocale } from './LocaleUtil/languageList';

const PerformanceNavigationTypes = {
    0: 'TYPE_NAVIGATE',
    1: 'TYPE_RELOAD',
    2: 'TYPE_BACK_FORWARD',
    255: 'TYPE_RESERVED'
};

function getTiming(name) {
    // eslint-disable-next-line no-mixed-operators
    return window.performance && performance.timing && performance.timing[name] || NaN;
}

function getTimingValue(startProperty, endProperty) {
    const start = getTiming(startProperty);
    const end = getTiming(endProperty);
    const value = start - end;

    if (Number.isNaN(value)) {
        return undefined;
    }

    return value;
}

function getReactRenderTiming(viewNavStartTime) {
    const start = viewNavStartTime;
    const stop = new Date().getTime();

    return stop - start;
}

function getPerformanceNavigationRedirectCount(initialLoadTTI) {
    if (initialLoadTTI) {
        return 0;
    }
    if (window.performance && window.performance.navigation
        && window.performance.navigation.redirectCount !== undefined) {
        return window.performance.navigation.redirectCount;
    }
    return 0;
}

function getLanguageId() {
    if (window.analyticsdatalayer) {
        return langIdOnLocale(window.analyticsdatalayer.displaylocale);
    }
    return 'unknown';
}

function getPerformanceNavigationType(initialLoadTTI) {
    const displayTypeDefault = 'UNKNOWN';
    let displayType = displayTypeDefault;
    let type;

    if (initialLoadTTI) {
        // eslint-disable-next-line prefer-destructuring
        displayType = PerformanceNavigationTypes[0];
    } else if (window.performance && window.performance.navigation
        && window.performance.navigation.type !== undefined) {
        // eslint-disable-next-line prefer-destructuring
        type = window.performance.navigation.type;

        if (PerformanceNavigationTypes[type] !== undefined) {
            displayType = PerformanceNavigationTypes[type];
        } else {
            displayType = `${displayTypeDefault}::${type}`;
        }
    }

    return displayType;
}

function getTimingCalculations(initialLoadTTI, viewNavStartTime, params) {
    let calculations = {};

    if (initialLoadTTI) {
        calculations = {
            appCacheTime: 0,
            unloadTime: 0,
            redirectTime: 0,
            dnsTime: 0,
            connectionTime: 0,
            requestTime: 0,
            responseTime: 0,
            parsingTime: 0,
            domReadyCallbackTime: 0,
            onLdCallbackTime: 0,
            processingTime: 0,
            navigationToFetchStart: 0,
            navigationToOnLd: 0,
            navigationToResponse: 0,
            navigationToDomContentLoaded: 0,
            fetchToResponse: 0,
            fetchToDomContentLoaded: 0,
            fetchToOnLd: 0,
            responseToDomContentLoaded: 0,
            responseToOnLd: 0,
            navigationToDomInteractive: getReactRenderTiming(viewNavStartTime)
        };
    } else {
        calculations = {
            appCacheTime: getTimingValue('domainLookupStart', 'fetchStart'),
            unloadTime: getTimingValue('unloadEventEnd', 'unloadEventStart'),
            redirectTime: getTimingValue('redirectEnd', 'redirectStart'),
            dnsTime: getTimingValue('domainLookupEnd', 'domainLookupStart'),
            connectionTime: getTimingValue('connectEnd', 'connectStart'),
            requestTime: getTimingValue('responseStart', 'requestStart'),
            responseTime: getTimingValue('responseEnd', 'responseStart'),
            parsingTime: getTimingValue('domInteractive', 'domLoading'),
            domReadyCallbackTime: getTimingValue('domContentLoadedEventEnd', 'domContentLoadedEventStart'),
            onLdCallbackTime: getTimingValue('loadEventEnd', 'loadEventStart'),
            processingTime: getTimingValue('domComplete', 'domLoading'),
            navigationToFetchStart: getTimingValue('fetchStart', 'navigationStart'),
            navigationToOnLd: getTimingValue('loadEventStart', 'navigationStart'),
            navigationToResponse: getTimingValue('responseStart', 'navigationStart'),
            navigationToDomContentLoaded: getTimingValue('domContentLoadedEventStart', 'navigationStart'),
            fetchToResponse: getTimingValue('responseStart', 'fetchStart'),
            fetchToDomContentLoaded: getTimingValue('domContentLoadedEventStart', 'fetchStart'),
            fetchToOnLd: getTimingValue('loadEventStart', 'fetchStart'),
            responseToDomContentLoaded: getTimingValue('domContentLoadedEventStart', 'responseStart'),
            responseToOnLd: getTimingValue('loadEventStart', 'responseStart'),
            navigationToDomInteractive: getTimingValue('domInteractive', 'navigationStart')
        };
    }


    Object.keys(calculations).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(calculations, key)
            && calculations[key] !== undefined) {
            params.push(`${key}=${calculations[key]}`);
        }
    });

    return params;
}

export {
    getTiming, getPerformanceNavigationRedirectCount, getLanguageId,
    getPerformanceNavigationType, getTimingCalculations
};
